import { Sex, SlotType } from "utils/interfaces"

export const SEX_LABELS: Record<Sex, string> = {
    [Sex.Male]: "мужской",
    [Sex.Female]: "женский",
    [Sex.Any]: "не принципиально",
}

export const SLOT_TYPE_LABELS: Partial<Record<SlotType, string>> = {
    [SlotType.Online]: "онлайн",
    [SlotType.InPerson]: "лично",
    [SlotType.Any]: "не принципиально",
}
